// polyfill
import '@babel/polyfill';
import 'react-app-polyfill/ie9';
import 'url-search-params-polyfill';
// bootstrap
import bootstrap from 'bootstrap';
